export default __webpack_public_path__ + "../staticImages/weinberg-260.png";